<template>
	<section class="content redesign">
		<div class="row">
			<div class="col-lg-6">
				<div class="card border">
					<div class="card-header h6">
						Informasi Pengiriman
					</div>
					<div class="card-body">
						<div class="form-group">
							<label class="control-label">Asal Pengiriman</label>
							<v-select required label="name" name="sender_addr_id" :filterable="false" :options="addrOptions1" :getOptionLabel="addrOptions1 => formData.sender_addr_id" v-model="formData.sender_addr_id" :reduce="(opt) => opt.id" @search="onSearch1" >
							<template slot="no-options"> Ketik asal pengiriman... </template>
							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.lokasi }}
								</div>
							</template>
							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.lokasi }}
								</div>
							</template>
							</v-select>
						</div>
						<div class="form-group">
							<label class="control-label">Tujuan Pengiriman</label>
							<v-select required label="name" name="addr_id" :filterable="false" :options="addrOptions2" :getOptionLabel="addrOptions2 => formData.addr_id" v-model="formData.addr_id" :reduce="(opt) => opt.id" @search="onSearch2">
							<template slot="no-options"> Ketik tujuan pengiriman... </template>
							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.lokasi }}
								</div>
							</template>
							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.lokasi }}
								</div>
							</template>
							</v-select>
						</div>
						<div class="form-group">
							<label class="control-label">Berat (Kg)</label>
							<input @change="resetOngkir()" class="form-control" v-model="formData.weight" type="number" value="1" min="0.1" max="99" step="0.1" required="required" placeholder="Bisa desimal" name="weight" 
								onkeydown="return (event.ctrlKey || event.altKey 
								|| (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
								|| (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
								|| (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))"/>
						</div>
						<div class="row">
							<div class="col-md-4 form-group">
								<label class="control-label">Panjang (Cm)</label>
								<input @change="resetOngkir()" class="form-control" v-model="formData.length" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="length" 
									onkeydown="return (event.ctrlKey || event.altKey 
										|| (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
										|| (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
										|| (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))" />
							</div>
							<div class="col-md-4 form-group">
								<label class="control-label">Lebar (Cm)</label>
								<input @change="resetOngkir()" class="form-control" v-model="formData.width" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="width" 
									onkeydown="return (event.ctrlKey || event.altKey 
										|| (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
										|| (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
										|| (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))" />
							</div>
							<div class="col-md-4 form-group">
								<label class="control-label">Tinggi (Cm)</label>
								<input @change="resetOngkir()" class="form-control" v-model="formData.height" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="height" 
									onkeydown="return (event.ctrlKey || event.altKey 
										|| (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
										|| (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
										|| (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))" />
							</div>
						</div>
						<div class="form-group">
							<div class="row">
								<div class="col">
									<label class="font-weight-normal">Apa tipe pengirimanmu?</label>
								</div>
							</div>
							<div class="form-group">
								<div class="row">
									<div class="col">
										<div class="form-control h-100" v-bind:class="{ 'border-primary' : formData.codStatus }" v-bind:style="{ backgroundColor: formData.codStatus ? '#ffe1c9' : '#fff' }" style="border-width: 2px;">
											<div class="icheck-material-orange w-100">
												<input type="radio" id="cod" name="cod-status" v-model="formData.codStatus" v-bind:value="true" :disabled="codDisabled" required />
												<label for="cod" class="form-check-label w-100">COD</label>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="form-control h-100" v-bind:class="{ 'border-primary' : !formData.codStatus }" v-bind:style="{ backgroundColor: !formData.codStatus ? '#ffe1c9' : '#fff' }" style="border-width: 2px;">
											<div class="icheck-material-orange w-100">
												<input type="radio" id="reg" name="cod-status" v-model="formData.codStatus" v-bind:value="false" required />
												<label for="reg" class="form-check-label w-100">Non - COD</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group">
							<label class="control-label">Nilai Paket <span class="text-primary">(wajib diisi)</span></label>
							<currency-input 
								class="form-control" 
								currency="IDR" 
								v-model="formData.itemValue" 
								@keyup="hitungBiaya()" 
								@keypress="cegahMinus" 
								:precision="0" 
								placeholder="Masukkan nilai paket" 
								required 
							/>
							<small class="form-text text-muted">
								Nilai barang (tidak ditagihkan ke customer, untuk perhitungan garansi asuransi)
							</small>
						</div>

						<div class="form-group" v-if="formData.codStatus">
							<label class="control-label">Nilai COD</label>
							<currency-input 
								class="form-control" 
								currency="IDR" 
								v-model="formData.codValue" 
								@keyup="hitungBiaya()" 
								@keypress="cegahMinus" 
								:precision="0" 
								placeholder="Masukkan nilai COD" 
								required 
							/>
							<small class="form-text text-muted">
								Total nilai barang + ongkir yang ditagihkan ke customer
							</small>
						</div>

						<div class="form-group mb-0">
							<button :disabled="checking || !formData.sender_addr_id || !formData.addr_id || !formData.weight || !formData.itemValue" v-on:click="search" class="btn btn-primary btn-lg btn-block">
								<i class="fas fa-search"></i>
								Cek Ongkos Kirim
								<span v-if="checking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="card border mb-3">
					<div class="card-header h6">
						Kurir Pengiriman
					</div>
					<div class="card-body">
						<div class="form-group">
							<div v-if="showServiceList" class="d-flex flex-column" style="gap: 0.5rem;">
								<div class="form-control h-100 py-3 cursor-pointer" v-on:click="selectService(sid, list.drop_off); stopLoadOngkir()" v-for="(list, sid) in resultOngkir" v-bind:key=sid>
									<div class="row align-items-center">
										<div class="col-auto d-flex justify-content-center align-items-center px-0 px-sm-2" style="max-width: 30%;max-height: 33.275px">
											<img :src="getKurirLogo(list.kurir)" style="max-width: 100%;max-height: 60px;" />
										</div>
										<div class="col">
											<div class="font-weight-bold">{{ list.kurir + ' ' + list.serviceName }}</div>
											<div class="text-xs">{{ list.etd_from == 0 || list.etd_thru == 0 ? '&#8212;' : list.etd_from + '-' + list.etd_thru + ' hari' }}</div>
										</div>
										<div class="col-auto text-right">
											<del class="text-xs text-danger">{{ list.disc != 0 ? 'Rp ' + formatPrice(list.maxPrice) : '&nbsp;' }}</del>
											<div class="font-weight-bold">Rp {{ list.ppn_ongkir_inc == 0 ? formatPrice((list.price - list.disc) * (100 + list.ppn_ongkir) / 100) : formatPrice(list.price - list.disc) }}</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="service.id" class="form-control h-100 py-3 border-primary cursor-pointer" style="background-color: #ffe1c9;border-width: 2px;" v-on:click="showServiceOption">
								<div class="row">
									<div class="col-auto d-flex justify-content-center align-items-center px-0 px-sm-2" style="max-width: 30%;max-height: 33.275px">
										<img :src="getKurirLogo(service.kurir)" style="max-width: 100%;max-height: 60px;" />
									</div>
									<div class="col">
										<div class="font-weight-bold">{{ service.kurir + ' ' + service.serviceName }}</div>
										<div class="text-xs">{{ service.etd_from == 0 || service.etd_thru == 0 ? '&#8212;' : service.etd_from + '-' + service.etd_thru + ' hari' }}</div>
									</div>
									<div class="col-auto text-right">
										<del class="text-xs text-danger">{{ service.disc != 0 ? 'Rp ' + formatPrice(service.maxPrice) : '&nbsp;' }}</del>
										<div class="font-weight-bold">Rp {{ service.ppn_ongkir_inc == 0 ? formatPrice((service.price - service.disc) * (100 + service.ppn_ongkir) / 100) : formatPrice(service.price - service.disc) }}</div>
									</div>
								</div>
							</div>
							<div v-else class="form-control d-flex justify-content-between align-items-center h-100 py-3 cursor-pointer">
								<div class="text-muted">
									<div class="font-weight-bold">Pilih kurir pengirimanmu</div>
									<div class="mt-2">Pilih kurir favoritmu dan nikmati diskon dari bosCOD!</div>
								</div>
								<!-- <i class="fi fi-rr-angle-right" style="opacity: 25%;"></i> -->
							</div>
							<div class="row mt-2" v-if="formData.sender_addr_id && formData.addr_id && ongkirInProgres.length < listCourier.length">
								<div class="col">
									<div class="progress rounded-pill">
										<div class="progress-bar progress-bar-striped progress-bar-animated" :class="['bg-primary']" role="progressbar" v-bind:aria-valuenow="(ongkirInProgres.length / listCourier.length) * 100" aria-valuemin="0" aria-valuemax="100" :style="{ 'width': (ongkirInProgres.length / listCourier.length) * 100 + '%' }">{{ (ongkirInProgres.length / listCourier.length) * 100 }}%</div>
									</div>
								</div>
								<div class="col-auto pl-0">
									<i class="fi fi-rr-cross cursor-pointer" v-on:click="stopLoadOngkir"></i>
								</div>
							</div>
						</div>
						<div class="form-group mb-0">
							<div class="row">
								<div class="col">
									<div class="form-control h-100" v-if="!showServiceList && service">
										<div class="icheck-material-orange w-100">
											<input type="checkbox" id="insurance" v-model="formData.insurance_type" @change="hitungBiaya()" :disabled="insuranceChangeDisabled" />
											<label for="insurance" class="form-check-label w-100">Asuransi</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card border">
					<div class="card-header h6">
						Rincian Pembayaran
					</div>
					<div class="card-body">
						<div class="form-group" v-if="formItem.shippingCost && !showServiceList">
							<div class="d-flex flex-column mt-1" style="gap: 6px">
								<div class="d-flex justify-content-between">
									<span>Berat Paket {{ isVolumetric ? '(Volumetrik)' : '' }}</span>
									<span>{{ displayWeight }} Kg</span>
								</div>

								<div class="d-flex justify-content-between" v-if="formData.codStatus && !formData.codValue">
									<span>Nilai COD</span>
									<span>Rp {{ formatPrice(codValueCalc) }}</span>
								</div>

								<div class="d-flex justify-content-between">
									<span>Nilai Paket</span>
									<span>Rp {{ formatPrice(formData.itemValue) }}</span>
								</div>

								<div class="d-flex justify-content-between">
									<span :class="{ 'cursor-pointer': formData.codStatus }" @click="toggleDetail">
										Ongkir <span v-if="formData.codStatus">dan COD Fee</span> (Termasuk PPN)
										<i class="fi" :class="showDetail ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'" v-if="formData.codStatus"></i>
									</span>
									<span>Rp {{ formatPrice(formData.codStatus ? formItem.shippingCost + codFeeTotal : formItem.shippingCost) }}</span>
								</div>

								<div class="d-flex justify-content-between" style="opacity: .5" v-if="formData.codStatus && showDetail">
									<span>Ongkir + PPN</span>
									<span>Rp {{ formatPrice(formItem.shippingCost) }}</span>
								</div>
								<div class="d-flex justify-content-between" style="opacity: .5" v-if="formData.codStatus && showDetail">
									<span>COD Fee + PPN</span>
									<span>Rp {{ formatPrice(codFeeTotal) }}</span>
								</div>

								<div class="d-flex justify-content-between">
									<span>Biaya Asuransi</span>
									<span>Rp {{ formatPrice(formItem.insuranceFee) }}</span>
								</div>

								<hr class="m-0 border-secondary" style="border-style: dashed; border-width: thin;" />

								<div class="d-flex justify-content-between">
									<span>{{ formData.codStatus ? 'Nilai yang kamu terima' : 'Total' }}</span>
									<span class="font-weight-bold" :style="{ color: totalValue < 0 ? '#ab0007' : '#00ab4f' }">
										Rp {{ formatPrice(totalValue) }}
									</span>
								</div>
							</div>
							<div class="mt-2 pt-1">
								<div class="d-flex justify-content-between font-weight-bold">
									<span>{{ formData.codStatus ? 'Ditagihkan ke customer' : 'Total Pembayaran' }}</span>
									<span>Rp {{ formatPrice(formData.codStatus ? (formData.codValue > 0 ? formData.codValue : Math.ceil((parseInt(formData.itemValue) + formItem.shippingCost + formItem.insuranceFee) / (1-((formItem.codFeeRate / 100) + ((formItem.codPpnRate / 100) * (formItem.codFeeRate / 100)))))) : formItem.shippingCost + formItem.insuranceFee) }}</span>
								</div>
							</div>
						</div>
						<div class="form-group" v-else>
							<div class="row">
								<div class="col-12 col-sm-8 col-md-5 col-lg-auto m-auto">
									<img src="../assets/img/search-engines-amico.svg" class="d-flex m-auto" />
									<div class="text-center">
										<span class="font-20-bold">Rincian Pembayaran Kosong</span><br/>
										<span class="font-14-medium text-neutral-dark-03">Lengkapi terlebih dahulu data kalkulator pengiriman dan pilih kurir yang tersedia</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import { createTable, authFetch, formatCurrency } from '@/libs/hxcore';
import $ from 'jquery';
// import datepicker from '@/components/Datepicker';
import { CurrencyInput } from "vue-currency-input";
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import moment from "moment";
import "icheck-material";

export default {
	name: 'Calculator',
	components: {
		vSelect,
		// datepicker,
		CurrencyInput
	},
	data() {
		return {
			errors: [],
			addrOptions1: [],
			addrOptions2: [],
			senderOptions: [],
			resultOngkir: [],
			roles: '',
			checking: false,
			showDetail:false,
			formData: {
				addr_id: '',
				sender_addr_id: '',
				weight: 1,
				width: 10,
				length: 10,
				height: 10,
				codStatus: true,
				insurance_type:true,
				codValue: 0,
				itemValue: 0,
				courier_id: 0,
			},
			onChange:true,
			// tgl: '',
			// kelas: '',
			signals: null,
			totalCourier: [],
			listCourier: [],
			ongkirInProgres: [],
			service: {
				id: "",
				kurir: "",
				service: "",
				serviceName: "",
				etd_from: 0,
				etd_thru: 0,
				price: 0,
				maxPrice: 0,
				disc: 0,
				ppn: 0,
				ppn_ongkir: 0,
				ppn_ongkir_inc: 0,
				ins: 0,
				insmin: 0,
				insfee: 0,
				feecod: 0,
				weight:0
			},
			formItem: {
				shippingCost: 0,
				codFeeAmount: 0,
				codFeeRate: 0,
				codPpnRate: 0,
				insuranceFee: 0,
				totalReceived: 0,
			},
			availableCost:true,
			showServiceList:false,
			ServiceCodExcept:["ANTERAJASD"],
			insuranceExcept:["ANTERAJA", "JNE", "NINJACARGO"],
			insuranceCourier: process.env.VUE_APP_INSURANCE_COURIER ? process.env.VUE_APP_INSURANCE_COURIER.split(",") : ['JNE', 'NINJACARGO', 'SPX', 'SiCepat', 'SiCepatNew'],
		}
	},
	created: function() {
		this.loadSenderAddress();
	},
	methods: {
		// ===== Helper tampilan =====
		formatPrice(data) {
			return formatCurrency(data);
		},
		getKurirLogo(kurir) {
			const fileName = kurir.toLowerCase();
			return require(`../assets/img/${fileName}.png`) // the module request
		},
		toggleDetail() {
			this.showDetail = !this.showDetail;
		},

		// ===== Load data alamat & kurir =====
		loadAddress() {
			authFetch("/order/cekongkir/address").then((res) => {
				res.json().then((json) => {
					if (json.success) {
						this.addrOptions1.push({
							id: json.data.addr_id,
							lokasi: json.data.kota + " / " + json.data.kecamatan,
						});

						this.addrOptions2.push({
							id: json.data.addr_id,
							lokasi: json.data.kota + " / " + json.data.kecamatan,
						});
					}
				});
			});
		},
		loadSenderAddress() {
			authFetch('/order/cekongkir/asalgudang')
			.then(res => {
				if (res.status === 201) {

				} else if (res.status === 400) {}
				return res.json();
			})
			.then(js => {
				this.senderOptions = js.data;
				$('.loading-overlay').removeClass('show');
			});
		},
		onSearch1(search, loading) {
			if (search.length > 3) {
				loading(true);
				//this.search(loading, search, this);
				var vm = this;
				authFetch(`/order/wilayah?q=${escape(search)}`).then((res) => {
					res.json().then((json) => (vm.addrOptions1 = json.items));
					loading(false);
				});
			}
		},
		onSearch2(search, loading) {
			if (search.length > 3) {
				loading(true);
				//this.search(loading, search, this);
				var vm = this;
				authFetch(`/order/wilayah?q=${escape(search)}`).then((res) => {
					res.json().then((json) => (vm.addrOptions2 = json.items));
					loading(false);
				});
			}
		},
		async loadCourier() {
			let route = "/order/kurir";

			try {
				await authFetch(route).then(res => {
					res.json().then(json => {
						if (json.success == true) {
							this.listCourier = json.data;
							this.mapOngkir();
						} else {
							Swal.fire({
								title: "Oops...",
								icon: "error",
								text: json.message,
								showCloseButton: true
							});
						}

					});
				});
			} catch (error) {
				console.error("Error fetching courier data:", error);
				Swal.fire({
					title: "Oops...",
					icon: "error",
					text: "Terjadi kesalahan saat memuat data kurir.",
					showCloseButton: true
				});
			}
		},
		// ===== Pencarian & pemetaan ongkir =====
		search: function() {
			this.checking = true;

			const checks = [
				{ cond: !this.formData.sender_addr_id, msg: "Asal pengiriman belum dipilih!" },
				{ cond: !this.formData.addr_id, msg: "Tujuan pengiriman belum dipilih!" },
				{ cond: this.formData.weight > 99, msg: "Berat maksimum 99 Kg!" },
				{ cond: this.formData.weight == 0, msg: "Berat harus di isi" },
			];

			for (const { cond, msg } of checks) {
				if (cond) {
					this.resultOngkir = [];
					this.checking = false;
					Swal.fire(msg, ``, "error");
					return false;
				}
			}

			this.stopLoadOngkir();
			this.mapOngkir();
		},
		stopLoadOngkir: function() {
			if (this.signals != null) {
				this.signals.abort();
				this.ongkirInProgres = [];
			}
		},
		mapOngkir() {
			const self = this;
			this.ongkirInProgres = [];
			this.resultOngkir = [];

			if (this.signals != null) {
				this.signals.abort();
			}

			this.signals = new AbortController();

			let data = this.listCourier.length > 0 ? this.listCourier.map((val,key) => {
				var data = {};
				data.addr_id = self.formData.addr_id;
				data.sender_addr_id = self.formData.sender_addr_id;
				data.weight = self.formData.weight;
				data.courier = val.id;
				data.order_type = this.formData.order_type;
				data.w = self.formData.width;
				data.h = self.formData.height;
				data.l = self.formData.length;
				this.newLoadOngkir(data);
			}) : this.loadCourier();
		},
		newLoadOngkir(params) {
			params.codStatus = 0;
			// rekomendasi kurir ID Express
			const courierRecommendation = 1;

			let data = Object.keys(params)
				.map(
					key =>
						encodeURIComponent(key) +
						"=" +
						(params[key] === false || params[key] === undefined
							? 0
							: encodeURIComponent(params[key]))
				)
				.join("&");

			this.checking = true;
			this.loadingOngkir = true;

			authFetch("/order/ongkir?" + data, {signal : this.signals.signal}).then(response => {
				response.json().then(json => {
					if (params.courier == courierRecommendation) {
						console.log(params.courier);
						const insertAt = 0;
						this.resultOngkir = [...json].concat(this.resultOngkir);
					} else {
						this.resultOngkir.push(...json);
					}

					this.checking = false;
					this.loadingOngkir = false;

					if (Object.keys(this.resultOngkir).length == 1 && Object.keys(this.listCourier).length == 1) {
						this.selectService(0);// if only one option
					} else {
						this.showServiceList = true;
					}

					this.ongkirInProgres.push(params.courier);
				})
				// .finish(
				// 	this.ongkirInProgres.push(...params.courier)
				// );
			});
		},
		// ===== Pemilihan layanan/kurir =====
		showServiceOption: function()
		{
			if (this.resultOngkir.length === 1) {
				return;
			}

			this.showServiceList = true;
			this.resetService();
		},
		resetOngkir: function()
		{
			this.resultOngkir = []
			this.showServiceList = false;
			this.resetService();
			this.resetFormItem();
		},
		resetFormItem: function()
		{
			this.formItem = {
				shippingCost: 0,
				codFeeAmount: 0,
				codFeeRate: 0,
				codPpnRate: 0,
				insuranceFee: 0,
				totalReceived: 0,
			};
			this.availableCost = true;
		},
		resetService: function() {
			this.service = {
				id: "",
				kurir: "",
				service: "",
				serviceName: "",
				etd_from: 0,
				etd_thru: 0,
				price: 0,
				maxPrice: 0,
				disc: 0,
				ppn: 0,
				ppn_ongkir: 0,
				ppn_ongkir_inc: 0,
				ins: 0,
				insmin: 0,
				insfee: 0,
				feecod: 0,
				weight:0
			};
		},
		selectService: function(sid, item)
		{
			this.service = this.resultOngkir[sid];
			this.formData.courier_id = this.service.id;
			this.showServiceList = false;
			this.hitungBiaya();
		},
		// ===== Kalkulasi biaya (ongkir, COD, asuransi, total) =====
		getBiayaAsuransi(item, service, nilai_ongkir)
		{
			if (!this.formData.insurance_type) {
				return 0;
			}

			var cod_fee_ppn = ((parseFloat(item.itemValue) + nilai_ongkir) / (1-((this.service.feecod / 100) + ((this.service.ppn / 100) * this.service.feecod / 100))) * (this.service.feecod / 100)) + (((parseFloat(item.itemValue) + nilai_ongkir) / (1-((this.service.feecod / 100) + ((this.service.ppn / 100) * this.service.feecod / 100))) * (this.service.feecod / 100)) * (this.service.ppn / 100))
			if (this.formData.courier_id == 7) {
				var itemVal = item.codValue > 0 ? item.codValue : (parseFloat(item.itemValue) + nilai_ongkir + cod_fee_ppn);
			} else if (this.formData.courier_id == 3) {
				var itemVal = item.codStatus == true ? (item.codValue > 0 ? item.codValue : (parseFloat(item.itemValue) + nilai_ongkir + cod_fee_ppn)) : item.itemValue;
			} else {
				var itemVal = parseFloat(item.itemValue);
			}

			var insFee = 0;
			if (itemVal > service.insmin) {
				if (service.insfee) {
					insFee = service.insfee;
				} else if (service.ins) {
					insFee = (service.ins * itemVal) / 100;
				}
			}

			if ((this.formData.courier_id == 5 || this.formData.courier_id == 10) && insFee < 2750) {
				insFee = 2750;
			}

			if (service.ppn_insurance > 0) {
				insFee = Math.round(insFee + (insFee * service.ppn_insurance / 100));
			}

			return insFee;
		},
		getBiayaOngkir(item, service)
		{
			var nilai_ongkir = service.price - service.disc;
			if (service.ppn_ongkir_inc == 0) {
				// var xnilai_ongkir = nilai_ongkir * 100 / (100 + service.ppn_ongkir);
				var xnilai_ongkir = Math.round((nilai_ongkir * (100 + service.ppn_ongkir)) / 100);
				nilai_ongkir = xnilai_ongkir;
				// nilai_ongkir = nilai_ongkir * 1.01; // +ppn 1%
			}
			return nilai_ongkir;
		},
		getBiayaCOD(item, service)
		{
			if (item.codStatus) {
				var codFee = ((item.codValue > 0 ? item.codValue : parseFloat(item.itemValue)) * service.feecod) / 100;
				var totalFeeCod = codFee + (codFee * service.ppn) / 100;
				return totalFeeCod;
			} 
			return 0;
		},
		hitungBiaya: function() {
			var cod_value = this.formData.codStatus ? (parseFloat(this.formData.codValue) || 0) : 0;

			var nilai_ongkir = this.getBiayaOngkir(this.formData, this.service);
			var feeCod = this.getBiayaCOD(this.formData, this.service);
			var insFee = this.getBiayaAsuransi(this.formData, this.service, nilai_ongkir);

			this.formItem.shippingCost = nilai_ongkir;
			this.formItem.codFeeAmount = feeCod;
			this.formItem.codPpnRate = this.service.ppn;
			this.formItem.codFeeRate = this.service.feecod;
			this.formItem.insuranceFee = insFee;
			
			this.formItem.totalReceived = cod_value - nilai_ongkir - feeCod - insFee;

			if (this.formData.codStatus) {
				this.availableCost = (this.formItem.totalReceived > 0);
			} else {
				this.availableCost = true;
			}
		},
		cegahMinus(e) {
			if (e.key === '-' || e.key === 'Minus') {
				e.preventDefault();
			}
		},
	},
	mounted() {
		const e = this.$refs;
		var self = this;
	},
	computed: {
		isVolumetric() {
			return this.formData.weight < this.service.weight;
		},
		displayWeight() {
			return this.isVolumetric ? this.service.weight : this.formData.weight;
		},
		codValueCalc() {
			if (this.formData.codValue > 0) return this.formData.codValue;
			const base = parseInt(this.formData.itemValue) + this.formItem.shippingCost + this.formItem.insuranceFee;
			const rate = (this.formItem.codFeeRate / 100) + ((this.formItem.codPpnRate / 100) * (this.formItem.codFeeRate / 100));
			return Math.ceil(base / (1 - rate)); 
		},
		codFeeTotal() {
			const fee = this.codValueCalc * (this.formItem.codFeeRate / 100);
			return fee + (fee * (this.formItem.codPpnRate / 100));
		},
		totalValue() {
			if (this.formData.codStatus) {
				return this.formData.codValue ? this.formItem.totalReceived : parseInt(this.formData.itemValue);
			}
			return this.formItem.shippingCost + this.formItem.insuranceFee;
		},
		codStatus: function() {
			return this.formData.codStatus;
		},
		senderAddress: function() {
			return this.formData.sender_addr_id;
		},
		receiverAddress: function() {
			return this.formData.addr_id;
		},
		nilaiCod: function() {
			return this.formData.codValue;
		},
		codDisabled: function() {
			return this.ServiceCodExcept.includes(this.service.service) || this.verifikasiKtp == 0;
		},
		insuranceChangeDisabled: function() {
			return (this.insuranceExcept.includes(this.service.kurir) && this.formData.codStatus) || this.insuranceCourier.includes(this.service.kurir);
		}
	},
	watch: {
		ongkirInProgres: function(val) {
			if (Object.keys(this.ongkirInProgres).length == Object.keys(this.listCourier).length == 1) {
				this.signals = null;
			}
		},
		codStatus: function(val) {
			this.hitungBiaya();
		},
		senderAddress: function() {
			this.resetOngkir();
		},
		receiverAddress: function() {
			this.resetOngkir();
		},
		nilaiCod: function(val) {
			this.hitungBiaya();
		},
		codDisabled(isDisabled) {
			if (isDisabled) {
				this.formData.codStatus = false;
			}
		},
		insuranceChangeDisabled(isDisabled) {
			if (isDisabled) {
				this.formData.insurance_type = true;
			}
		},

	},
}
</script>